import { useCallback, useEffect, useRef, useState } from 'react';
import { gcoinRequest } from '../gcoinApi';

export default function useGCoinWallet(token) {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [updatedAt, setUpdatedAt] = useState(null);
    const active = useRef(false);
    const expanded = useRef(false);
    const controller = useRef(null);
    const sequence = useRef(0);
    const load = useCallback(async (beforeId = null, { auto = false } = {}) => {
        if (auto && (document.hidden || active.current || expanded.current)) return;
        active.current = true;
        controller.current?.abort();
        const abort = new AbortController(); controller.current = abort;
        const id = ++sequence.current;
        setLoading(true); setError('');
        try {
            const result = await gcoinRequest(token, `me/?limit=30${beforeId ? `&before_id=${beforeId}` : ''}`, { signal: abort.signal });
            if (id !== sequence.current) return;
            expanded.current = !!beforeId;
            setUpdatedAt(new Date());
            setData(prev => ({ ...result, results: beforeId ? [...(prev?.results || []), ...result.results] : result.results }));
        } catch (err) { if (!abort.signal.aborted && id === sequence.current) setError(err.message); }
        finally { if (id === sequence.current) { setLoading(false); active.current = false; } }
    }, [token]);
    useEffect(() => { load(); return () => { ++sequence.current; controller.current?.abort(); }; }, [load]);
    useEffect(() => {
        const timer = setInterval(() => load(null, { auto: true }), 30000);
        return () => clearInterval(timer);
    }, [load]);
    return { data, loading, error, load, updatedAt };
}